import * as React from 'react';
import { Feature, IActionPointInfo, ServiceNames } from '@tencent/workbench';
import BaseToolbarFeature from '../../../common/feature/base-toolbar-feature';
import { config } from './config';
import TableMenu from '@com/tool-bar/menu/table-menu';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';

@Feature()
export class InsertTableFeature extends BaseToolbarFeature {
    public id = config.id;

    public constructor() {
        super();
    }

    public async onClick() {
        const copyPasteImageService = await this.getAppService().editableServiceLayer?.copyPasteImageService?.promise();
        const { ImageEditManager } = copyPasteImageService ?? {};
        const imageManager = ImageEditManager?.getInstance();

        const input = document.getElementById('select_pic_input');
        input?.click();
        this.getAppService().viewableServiceLayer.toolbarStateManager.lastInsertButtonClick = 1;
        if (imageManager) {
            imageManager.imageReplacing = false;
        }
    }

    public getContent(info: IActionPointInfo) {
        const style = info.from === ServiceNames.TOOLBAR ? {
            width: '200px',
            overflow: 'hidden',
            height: 'auto',
            backgroundColor: 'hsla(0,0%,100%,.92)',
            border: '1px solid rgba(0,0,0,.12)',
            borderRadius: '4px',
            padding: '16px 0 8px 0',
            boxShadow: '0 2px 12px 2px rgba(68,73,77,.16)',
        } : {};
        return (
            <TableMenu fromMenu={true} hideMenu={() => {}} style={style} wbPath={info.path}/>
        );
    }

    protected getCustomDisabledState(): boolean {
        const { pptEditorState } = this.getUserPriviledgeService();
        return this.shouldDisableInMaster(config.id) || (pptEditorState !== PPTEditorStateType.EDITABLE);
    }
}
